import "aos/dist/aos.css";
import LoveLetter from "../components/LoveLetter";
import PhotoGallery from "../components/PhotoGallery";
import MovieList from "../components/MovieList";
import Navbar from "../components/Navbar";


const Home: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-16">
        <LoveLetter />
        <PhotoGallery />
        <MovieList />
      </div>
    </div>
  );
};

export default Home;
